export default __webpack_public_path__ + "static/media/logofr.4fc8ca02.svg";